
import React from "react";

interface StatusBadgeProps {
  status: string;
  hasUnpaidBills: boolean;
  endDate?: string | null;
}

export function StatusBadge({ status, hasUnpaidBills, endDate }: StatusBadgeProps) {
  // Function to format date in a shorter format
  const formatDate = (dateString: string | null | undefined): string => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
    });
  };

  if (status === 'pending' || hasUnpaidBills) {
    return (
      <div className="inline-flex items-center gap-1.5 bg-amber-100 text-amber-800 px-3 py-1 rounded-full text-sm">
        <span className="h-2 w-2 rounded-full bg-amber-500"></span>
        Pending Payment
      </div>
    );
  } else if (status === 'active') {
    return (
      <div className="inline-flex items-center gap-1.5 bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm">
        <span className="h-2 w-2 rounded-full bg-green-500"></span>
        Active
      </div>
    );
  } else if (status === 'terminated') {
    return (
      <div className="inline-flex items-center gap-1.5 bg-orange-100 text-orange-800 px-3 py-1 rounded-full text-sm">
        <span className="h-2 w-2 rounded-full bg-orange-500"></span>
        {endDate && new Date(endDate) > new Date() ? 
          `Terminated - Active until ${formatDate(endDate)}` : 
          'Terminated'}
      </div>
    );
  } else if (status === 'cancelled') {
    return (
      <div className="inline-flex items-center gap-1.5 bg-red-100 text-red-800 px-3 py-1 rounded-full text-sm">
        <span className="h-2 w-2 rounded-full bg-red-500"></span>
        Cancelled
      </div>
    );
  } else {
    return (
      <div className="inline-flex items-center gap-1.5 bg-gray-100 text-gray-800 px-3 py-1 rounded-full text-sm">
        <span className="h-2 w-2 rounded-full bg-gray-500"></span>
        {status.charAt(0).toUpperCase() + status.slice(1)}
      </div>
    );
  }
}
